import { render, staticRenderFns } from "./register-form.vue?vue&type=template&id=1a11cd6a&scoped=true&"
import script from "./register-form.vue?vue&type=script&lang=js&"
export * from "./register-form.vue?vue&type=script&lang=js&"
import style0 from "./register-form.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./register-form.vue?vue&type=style&index=1&id=1a11cd6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a11cd6a",
  null
  
)

export default component.exports